<template>
  <div class="container">
    <div class="box">
      <!-- <div class="header">
        <el-button
          type="primary"
          @click="addBtn"
        >添加</el-button>
      </div> -->
      <div class="list">
        <el-table
          :data="dataList"
          border
          style="width: 100%"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="group-section">
                <div class="group-header">
                  <span>分组列表</span>
                  <el-button
                    type="primary"
                    size="small"
                    @click="addGroup(props.row)"
                  >新增分组</el-button>
                </div>
                <el-table
                  :data="props.row.groups || []"
                  border
                  style="width: 100%; margin-top: 10px"
                >
                  <el-table-column
                    label="分组名称"
                    prop="groupName"
                  ></el-table-column>
                  <el-table-column
                    label="分组图片"
                    prop="image"
                    width="120"
                  >
                    <template slot-scope="scope">
                      <el-image
                        v-if="scope.row.image && isImage(scope.row.image)"
                        style="width:60px;height:60px;"
                        fit="contain"
                        :src="scope.row.image"
                        :preview-src-list="[scope.row.image]"
                      ></el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="备注"
                    prop="remark"
                  ></el-table-column>
                  <el-table-column label="操作" width="220">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click="editGroup(props.row, scope.row)"
                      ><span>修改</span>
                      </el-button>
                      <el-button
                        type="text"
                        size="small"
                        @click="deleteGroup(scope.row.id)"
                      ><span>删除</span>
                      </el-button>
                      <el-button
                        type="text"
                        size="small"
                        @click="showGroupGoods(props.row, scope.row)"
                      ><span>商品列表</span>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="配置名称"
            prop="configName"
          ></el-table-column>
          <el-table-column
            label="购买数量"
            prop="buyAccount"
          ></el-table-column>
          <el-table-column
            label="赠送数量"
            prop="giftAccount"
          ></el-table-column>
          <el-table-column
            label="宣传图片"
            prop="img"
            width="150"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img && isImage(scope.row.img)"
                style="width:80px;height:80px;"
                fit="contain"
                :src="scope.row.img"
                :preview-src-list="[scope.row.img]"
              ></el-image>
              <video
                v-else-if="scope.row.img && isVideo(scope.row.img)"
                style="width:80px;height:80px;"
                :src="scope.row.img"
              ></video>
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            prop="remark"
          ></el-table-column>
          <el-table-column
            label="补贴%"
            prop="allowance"
          ></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="tableBtn(scope.row, 'view')"
              ><span>查看详情</span>
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="tableBtn(scope.row, 'edit')"
              ><span>修改</span>
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="tableBtn(scope.row, 'delete')"
              ><span>删除</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="addEditShow"
      width="600px"
      append-to-body
      @close="dialogClose()"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="100px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item
              label="配置名称:"
              prop="configName"
            >
              <el-input
                v-model.trim="form.configName"
                placeholder="配置名称"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="购买数量:"
              prop="buyAccount"
            >
              <el-input-number
                v-model="form.buyAccount"
                :min="1"
                :max="1000"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="赠送数量:"
              prop="giftAccount"
            >
              <el-input-number
                v-model="form.giftAccount"
                :min="0"
                :max="1000"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="补贴%:"
              prop="allowance"
            >
              <el-input-number
                v-model="form.allowance"
                :min="0"
                :max="100"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                v-model="form.remark"
                placeholder="备注"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="宣传图">
              <el-upload
                ref="imgUpload"
                list-type="picture-card"
                :limit="1"
                :file-list="imgFileList"
                :class="{ hide: hideImgUpload }"
                :action="getUploadUrl()"
                :before-upload="uploadBefore"
                :on-success="uploadSuccessImg"
                :on-remove="uploadRemoveImg"
                :show-file-list="true"
                :disabled="title === '查看详情'"
              >
                <i class="el-icon-plus"></i>
                <template #file="{ file }">
                  <div class="custom-upload-item">
                    <el-image
                      v-if="isImage(file.url)"
                      style="width:100%;height:100%;"
                      fit="contain"
                      :src="file.url"
                      :preview-src-list="[file.url]"
                    ></el-image>
                    <video
                      v-else-if="isVideo(file.url)"
                      controls
                      style="width:100%;height:100%;object-fit:contain;"
                      :src="file.url"
                    ></video>
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col
            :span="24"
            style="text-align: center"
          >
            <el-button
              v-if="title !== '查看详情'"
              type="primary"
              @click="confirmBtn()"
            >保存</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="groupTitle"
      :visible.sync="groupShow"
      width="500px"
      append-to-body
      @close="groupDialogClose()"
    >
      <el-form
        ref="groupFormRef"
        :model="groupForm"
        :rules="groupRules"
        label-width="100px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item
              label="分组名称:"
              prop="groupName"
            >
              <el-input
                v-model.trim="groupForm.groupName"
                placeholder="分组名称"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="分组图片">
              <el-upload
                ref="groupImgUpload"
                list-type="picture-card"
                :limit="1"
                :file-list="groupImgFileList"
                :class="{ hide: hideGroupImgUpload }"
                :action="getUploadUrl()"
                :before-upload="uploadBefore"
                :on-success="uploadSuccessGroupImg"
                :on-remove="uploadRemoveGroupImg"
                :show-file-list="true"
              >
                <i class="el-icon-plus"></i>
                <template #file="{ file }">
                  <div class="custom-upload-item">
                    <el-image
                      v-if="isImage(file.url)"
                      style="width:100%;height:100%;"
                      fit="contain"
                      :src="file.url"
                      :preview-src-list="[file.url]"
                    ></el-image>
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-delete" @click="handleGroupRemove(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                v-model="groupForm.remark"
                placeholder="备注"
                style="width: 100%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="24"
            style="text-align: center"
          >
            <el-button
              type="primary"
              @click="confirmGroupBtn()"
            >保存</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="groupGoodsTitle"
      :visible.sync="groupGoodsShow"
      width="1000"
      append-to-body
      @close="groupGoodsDialogClose()"
    >
      <div class="group-goods-header">
        <el-button
          type="primary"
          size="small"
          @click="addGroupGoods"
        >新增商品</el-button>
      </div>
      <el-table
        :data="groupGoodsList"
        border
        style="margin-top: 10px"
      >
        <el-table-column label="商品名称" prop="name"> </el-table-column>
            <el-table-column label="商品唯一键" prop="goodsUniqueKey" align="center" />
            <el-table-column label="图片" width="100" align="center">
              <template slot-scope="scope">
                <template v-if="isImage(scope.row.headImg[0])">
                  <el-image
                    style="width:80px;height:80px;"
                    fit="contain"
                    :src="scope.row.headImg[0]"
                    :preview-src-list="[scope.row.headImg]"
                  ></el-image>
                </template>
                <template v-else-if="isVideo(scope.row.headImg[0])">
                  <video
                    muted
                    autoplay="autoplay"
                    loop="loop"
                    style="width:80px;height:80px;"
                    fit="contain"
                    :src="scope.row.headImg[0]"
                    :preview-src-list="[scope.row.headImg]"
                  ></video>
                </template>
              </template>
            </el-table-column>

            <el-table-column label="价格" prop="retailPrice" width="140" align="center"></el-table-column>
            <el-table-column label="运费" prop="freight" width="140" align="center"></el-table-column>
            <el-table-column label="销量" prop="sales" width="140" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.sales">{{ scope.row.sales }}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column label="排序" prop="sort" width="140" align="center"></el-table-column>
            <el-table-column label="月限购" align="center" width="140">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isGroupHotSale" :active-value="1" :inactive-value="0"
                  :active-text="scope.row.isGroupHotSale ? '开启' : '关闭'" @change="changeIsGroupHotSale($event,scope)" />
              </template>


            </el-table-column>

            <el-table-column label="日限购" align="center" width="140">

              <template slot-scope="scope">
                <el-switch v-model="scope.row.dplimit" :active-value="1" :inactive-value="0"
                  :active-text="scope.row.dplimit ? '开启' : '关闭'" @change="changeDplimit($event,scope)" />
              </template>


            </el-table-column>
            <!-- <el-table-column label="状态" align="center" width="140">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.state" :active-value="1" :inactive-value="0"
                  :active-text="scope.row.state ? '已上架' : '已下架'" @change="changeGoodsState(scope)" />
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="发布时间" prop="createTime"></el-table-column> -->
            <!-- <el-table-column label="供应商联系方式" prop="supplierPhone"></el-table-column> -->
            <!-- <el-table-column label="备注" prop="remark"></el-table-column> -->
            <!-- <el-table-column label="操作" align="center" width="140" v-if="showView">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateGoods(scope)"><span>修改</span></el-button>
                <el-button type="text" size="small" @click="deleteGoods(scope)"><span>删除</span></el-button>
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="满减免单" align="center" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isExplosiveProducts&&scope.row.topPrice&&scope.row.decsPrice ? 'success' : 'danger'">
                  {{ scope.row.isExplosiveProducts&&scope.row.topPrice&&scope.row.decsPrice  ? "满"+scope.row.topPrice+'元减'+scope.row.decsPrice+"元" : '否' }}
                </el-tag>
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="半价优惠" align="center" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isBanjiaProducts ? 'success' : 'danger'">
                  {{ scope.row.isBanjiaProducts ? '是' : '否' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="会员免费" align="center" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isVipFreeProducts ? 'success' : 'danger'">
                  {{ scope.row.isVipFreeProducts ? '是' : '否' }}
                </el-tag>
              </template>
            </el-table-column> -->
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.state" :active-value="1" :inactive-value="0"
              :active-text="scope.row.state ? '已上架' : '已下架'" @change="changeGroupGoodsState(scope)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="editGroupGoods(scope.row)"
            ><span>修改</span>
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="deleteGroupGoods(scope.row.id)"
            ><span>删除</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="groupGoodsFormTitle"
        :visible.sync="groupGoodsFormShow"
        width="1200px"
        append-to-body
        @close="groupGoodsFormDialogClose()"
      >
        <el-form
          ref="groupGoodsFormRef"
          :model="groupGoodsForm"
          :rules="groupGoodsRules"
          label-width="80px"
          style="height: 580px;overflow-y: auto;"
        >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="商品类型" prop="atype">
                <el-select v-model="groupGoodsForm.atype" placeholder="请选择商品类型" clearable
                  style="width: 100%;">
                  <el-option v-for="(item, index) in groupGoodsType" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在门店" prop="storeId">
                <el-select v-model="groupGoodsForm.storeId" placeholder="请选择门店" clearable
                  style="width: 100%;" @change="onGroupGoodsStoreChange">
                  <el-option v-for="(item, index) in groupGoodsOptionsStore" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="商品分类" prop="categoryId">
                <el-select v-model="groupGoodsForm.categoryId" placeholder="请选择分类" clearable
                  style="width: 100%;">
                  <el-option v-for="item in groupGoodsOptionsCategory" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品售价" prop="retailPrice">
                <el-input v-model="groupGoodsForm.retailPrice" type="number" placeholder="请输入商品售价" maxlength="8"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="商品名称" prop="name">
                <el-input v-model="groupGoodsForm.name" type="text" placeholder="请输入商品名称" maxlength="30"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model="groupGoodsForm.sort" type="number" placeholder="请输入排序" maxlength="8"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="整体排序" prop="reorder">
                <el-input v-model="groupGoodsForm.reorder" type="number" placeholder="请输入排序" maxlength="8"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="描述" prop="brand">
                <el-input v-model="groupGoodsForm.brand" type="text" placeholder="请输入描述"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="信用积分" prop="score">
                <el-input v-model="groupGoodsForm.score" type="number" placeholder="" maxlength="8"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="金豆" prop="jingdou">
                <el-input v-model="groupGoodsForm.jingdou" type="number" placeholder="" maxlength="8"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="商品规格" prop="unit" v-for="(item, i) in groupGoodsUnnits" :key="i">
                <div class="unitBox">
                  <div class="unitTop">
                    <el-input
                      v-model="item.unitNum"
                      type="text"
                      placeholder="请输入规格"
                      style="width:388px"
                      class="input"
                    ></el-input>
                    <el-select
                      v-model="item.unit"
                      placeholder="请选择或输入单位"
                      class="input"
                      style="width:200px"
                      filterable
                      allow-create
                      reserve-keyword
                    >
                      <el-option
                        v-for="(option, index) in groupGoodsOptionsUnits"
                        :key="option.value"
                        :value="option.value"
                      />
                    </el-select>
                    <div class="goodsItem">
                      <span class="span spankc">库存</span>
                      <el-input class="input inputprice"
                        v-model="item.stock" type="number"
                        maxlength="8"
                        style="width: 97px;"
                      ></el-input>
                    </div>
                  </div>
                  <div class="unitBottom">
                    <div class="pricebox">
                      <div class="goodsItem">
                        <span class="span">顾客价</span>
                        <el-input class="input inputprice"
                          v-model="item.price" type="number"
                          maxlength="8"
                        ></el-input>
                      </div>
                      <div class="goodsItem">
                        <span class="span">会员价</span>
                        <el-input class="input inputprice"
                          v-model="item.membershipPrice" type="number"
                          maxlength="8"></el-input>
                      </div>
                      <div class="goodsItem">
                        <span class="span">VIP价</span>
                        <el-input class="input inputprice"
                          v-model="item.vipPrice"
                          type="number"
                          maxlength="8"></el-input>
                      </div>
                      <div class="goodsItem">
                        <span class="span">轻创价</span>
                        <el-input
                          class="input inputprice"
                          v-model="item.qcPrice"
                          type="number"
                          maxlength="8"
                        ></el-input>
                      </div>
                      <div class="goodsItem">
                        <span class="span">社区团长价</span>
                        <el-input
                          class="input inputprice"
                          v-model="item.communityLeaderPrice"
                          type="number"
                          maxlength="8"
                        ></el-input>
                      </div>
                      <div class="goodsItem">
                        <span class="span">运费</span>
                        <el-input
                          class="input inputprice"
                          v-model="item.shipcost"
                          type="number"
                          maxlength="8"
                        ></el-input>
                      </div>
                    </div>
                    <el-button
                      class="but butdel"
                      @click="groupGoodsReduce(i)"
                      v-if="i>=1"
                    >- 删除</el-button>
                  </div>
                </div>
                <el-button
                  class="addbutb"
                  @click="groupGoodsAddUnit"
                  v-if="i==groupGoodsUnnits.length-1"
                >+ 添加</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="商品简介" prop="details">
                <quill-editor
                  ref="groupGoodsQuillEditor"
                  v-model="groupGoodsForm.details"
                  :options="groupGoodsEditorOptions"
                  style="height: 200px; margin-bottom: 100px;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <el-col :span="24">
              <el-form-item label-width="0">
                <div class="goods-attr-line">
                  <span class="attr-label">七天无理由退货</span>
                  <el-checkbox v-model="groupGoodsForm.noreason" :true-label="1" :false-label="0"></el-checkbox>
                  <span class="attr-label">品质严保</span>
                  <el-checkbox v-model="groupGoodsForm.prem" :true-label="1" :false-label="0"></el-checkbox>
                  <span class="attr-label">急速退款</span>
                  <el-checkbox v-model="groupGoodsForm.instantrefund" :true-label="1" :false-label="0"></el-checkbox>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="满减免单">
                <el-switch
                  v-model="groupGoodsForm.isExplosiveProducts"
                  :active-value="1"
                  :inactive-value="0">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="半价优惠">
                <el-switch
                  v-model="groupGoodsForm.isBanjiaProducts"
                  :active-value="1"
                  :inactive-value="0">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-if="groupGoodsForm.isExplosiveProducts">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="满减条件">
                  <el-input
                    v-model="groupGoodsForm.topPrice"
                    type="number"
                    placeholder="请输入满减金额条件"
                    maxlength="8">
                    <template slot="prepend">满</template>
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="减免金额">
                  <el-input
                    v-model="groupGoodsForm.decsPrice"
                    type="number"
                    placeholder="请输入减免金额"
                    maxlength="8">
                    <template slot="prepend">减</template>
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="会员免费">
                <el-switch
                  v-model="groupGoodsForm.isVipFreeProducts"
                  :active-value="1"
                  :inactive-value="0">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="配送" prop="freight">
                <el-radio-group v-model="groupGoodsFreightValue">
                  <el-radio label="z">自提</el-radio>
                  <el-radio label="w">快递</el-radio>
                  <el-radio label="a">均可以</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="groupGoodsFreightValue=='w' || groupGoodsFreightValue=='a'">
            <el-col :span="12">
              <el-form-item label="运费金额" prop="freight">
                <el-input v-model="groupGoodsForm.freight" type="number" placeholder="请输入运费" maxlength="30"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="菜品类型">
                <el-select
                  v-model="groupGoodsForm.dishType"
                  placeholder="请选择菜品类型"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in groupGoodsStoreTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="销售佣金">
                <el-input
                  v-model="groupGoodsForm.salecomm"
                  placeholder="销售佣金"
                  maxlength="50"
                  class="input"
                  type="number"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="国补折扣">
                <el-input
                  v-model="groupGoodsForm.discount"
                  placeholder="国补折扣"
                  maxlength="50"
                  class="input"
                  type="number"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="公司分佣">
                <el-input
                  v-model="groupGoodsCommission"
                  placeholder="软件公司分佣"
                  maxlength="50"
                  class="input"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="是否用于霸王餐" label-width="80">
                <el-switch
                  v-model="groupGoodsForm.ifBawangcan"
                  :active-value="1"
                  :inactive-value="0"
                  :active-text="'开启'"
                  :inactive-text="'关闭'">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否充值大福利" label-width="80">
                <el-switch
                  v-model="groupGoodsForm.ifFuli"
                  :active-value="1"
                  :inactive-value="0"
                  :active-text="'开启'"
                  :inactive-text="'关闭'">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="24">
            <el-col>
              <el-form-item label="商品主图" prop="headImg">
                <el-upload
                  ref="groupGoodsMainUpload"
                  list-type="picture-card"
                  :limit="3"
                  :file-list="groupGoodsMainFileList"
                  :class="{ hide: hideGroupGoodsMainUpload }"
                  :action="getUploadUrl()"
                  :before-upload="uploadBefore"
                  :on-success="uploadSuccessGroupGoodsMain"
                  :on-remove="uploadRemoveGroupGoodsMain"
                  :show-file-list="true"
                >
                  <i class="el-icon-plus"></i>
                  <template #file="{ file }">
                    <div class="custom-upload-item">
                      <el-image
                        v-if="isImage(file.url)"
                        style="width:100%;height:100%;"
                        fit="contain"
                        :src="file.url"
                        :preview-src-list="[file.url]">
                      </el-image>
                      <video
                        v-else-if="isVideo(file.url)"
                        controls
                        style="width:100%;height:100%;object-fit:contain;"
                        :src="file.url">
                      </video>
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-delete" @click="handleGroupGoodsMainRemove(file)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col>
              <el-form-item label="商品配图">
                <el-upload
                  ref="groupGoodsNextUpload"
                  list-type="picture-card"
                  :limit="5"
                  :file-list="groupGoodsNextFileList"
                  :class="{ hide: hideGroupGoodsNextUpload }"
                  :action="getUploadUrl()"
                  :before-upload="uploadBefore"
                  :on-success="uploadSuccessGroupGoodsNext"
                  :on-remove="uploadRemoveGroupGoodsNext"
                  :show-file-list="true"
                >
                  <i class="el-icon-plus"></i>
                  <template #file="{ file }">
                    <div class="custom-upload-item">
                      <el-image
                        v-if="isImage(file.url)"
                        style="width:100%;height:100%;"
                        fit="contain"
                        :src="file.url"
                        :preview-src-list="[file.url]">
                      </el-image>
                      <video
                        v-else-if="isVideo(file.url)"
                        controls
                        style="width:100%;height:100%;object-fit:contain;"
                        :src="file.url">
                      </video>
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-delete" @click="handleGroupGoodsNextRemove(file)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col>
              <el-form-item label="经营资质">
                <el-upload
                  ref="groupGoodsQualificationUpload"
                  list-type="picture-card"
                  :limit="3"
                  :file-list="groupGoodsQualificationFileList"
                  :class="{ hide: hideGroupGoodsQualificationUpload }"
                  :action="getUploadUrl()"
                  :before-upload="uploadBefore"
                  :on-success="uploadSuccessGroupGoodsQualification"
                  :on-remove="uploadRemoveGroupGoodsQualification"
                  :show-file-list="true"
                >
                  <i class="el-icon-plus"></i>
                  <template #file="{ file }">
                    <div class="custom-upload-item">
                      <el-image
                        v-if="isImage(file.url)"
                        style="width:100%;height:100%;"
                        fit="contain"
                        :src="file.url"
                        :preview-src-list="[file.url]">
                      </el-image>
                      <video
                        v-else-if="isVideo(file.url)"
                        controls
                        style="width:100%;height:100%;object-fit:contain;"
                        :src="file.url">
                      </video>
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-delete" @click="handleGroupGoodsQualificationRemove(file)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col
              :span="24"
              style="text-align: center"
            >
              <el-button
                type="primary"
                @click="confirmGroupGoodsBtn()"
              >保存</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBawangcanListApi,
  addBawangcanApi,
  editBawangcanApi,
  deleteBawangcanApi,
  getBwcGroupListApi,
  addBwcGroupApi,
  editBwcGroupApi,
  deleteBwcGroupApi,
  getClassify,
  getSupplyOptions
} from "@/network/api.js";
import { goods_GCEditGoods, goods_GCAddGoods, goods_GCGetGoodsInfo } from '@/network/wApi';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { changedplimitSaleApi, changeGroupHotSaleApi, goods_GCRemoveGoodsById } from "../../network/wApi";

export default {
  name: "ConfigBawangcan",
  components: {
    quillEditor
  },
  data() {
    return {
      dataList: [],
      title: "",
      showView: true,  // 添加这一行
      addEditShow: false,
      form: {
        id: undefined,
        configName: "",
        buyAccount: 0,
        giftAccount: 0,
        allowance: 0,
        remark: "",
        img: "",
        ifBawangcan: 0,
        ifFuli:0
      },
      rules: {
        configName: [
          { required: true, message: "请输入配置名称", trigger: "change" }
        ],
        buyAccount: [
          { required: true, message: "请输入购买数量", trigger: "change" }
        ],
        giftAccount: [
          { required: true, message: "请输入赠送数量", trigger: "change" }
        ]
      },
      imgFileList: [],
      limitImg: 1,
      hideImgUpload: false,
      groupTitle: "",
      groupShow: false,
      groupForm: {
        id: undefined,
        groupName: "",
        remark: "",
        image: "",
        configId: ""
      },
      groupRules: {
        groupName: [
          { required: true, message: "请输入分组名称", trigger: "change" }
        ]
      },
      groupImgFileList: [],
      hideGroupImgUpload: false,
      currentConfigId: "",
      groupGoodsTitle: "",
      groupGoodsShow: false,
      groupGoodsList: [],
      currentGroupId: "",
      currentGroupConfigId: "",
      groupGoodsFormTitle: "",
      groupGoodsFormShow: false,
      groupGoodsForm: {
        id: undefined,
        name: "",
        retailPrice: "",
        atype: "",
        sort: "",
        reorder: null,
        brand: "",
        score: "",
        jingdou: "",
        details: "",
        headImg: [],
        imgList: [],
        unit: "",
        skuList: null,
        goodType: 1,
        freight: 0,
        isExplosiveProducts: 0,
        isBanjiaProducts: 0,
        isVipFreeProducts: 0,
        noreason: 0,
        prem: 0,
        instantrefund: 0,
        dishType: "",
        storeId: "",
        categoryId: "",
        salecomm: 0,
        discount: 0,
        ifBawangcan: 0,
        ifFuli: 0,
        qualification: [],
        groupId: ""
      },
      groupGoodsRules: {
        name: [
          { required: true, message: "请输入商品名称", trigger: "change" }
        ],
        retailPrice: [
          { required: true, message: "请输入商品售价", trigger: "change" }
        ]
      },
      groupGoodsCommission: "",
      groupGoodsFreightValue: "",
      groupGoodsType: [
        { label: "堂食商品", value: 1 },
        { label: "供应链商品", value: 3 }
      ],
      groupGoodsOptionsStore: [],
      groupGoodsOptionsCategory: [],
      groupGoodsOptionsUnits: [
        { value: '份' },
        { value: '个' },
        { value: '斤' },
        { value: '两' },
        { value: '克' },
        { value: '千克' },
        { value: '瓶' },
        { value: '杯' },
        { value: '碗' },
        { value: '袋' },
        { value: '盒' },
        { value: '条' },
        { value: '只' },
        { value: '片' },
        { value: '块' },
        { value: '串' },
        { value: '锅' },
        { value: '盅' },
        { value: '桶' },
        { value: '升' },
        { value: '毫升' },
        { value: '套餐' },
        { value: '人份' },
        { value: '半份' },
        { value: '小份' },
        { value: '中份' },
        { value: '大份' },
        { value: '特份' },
        { value: '双人份' },
        { value: '三人份' },
        { value: '四人份' },
        { value: '多人份' },
        { value: '家庭装' },
        { value: '豪华装' },
        { value: '尊享装' }
      ],
      groupGoodsUnnits: [
        {
          unitNum: '',
          unit: '',
          stock: '',
          price: '',
          membershipPrice: '',
          vipPrice: '',
          qcPrice: '',
          communityLeaderPrice: '',
          shipcost: ''
        }
      ],
      groupGoodsStoreTypeOptions: [
        { label: "全牛小面", value: "QNXM" },
        { label: "非遗酸汤火锅", value: "FYST" },
        { label: "香辣牛骨锅", value: "XLNG" },
        { label: "韩式烤肉", value: "HSKR" },
        { label: "牧歌烧烤", value: "MGSK" },
        { label: "广式烤鸭(饭)", value: "GSKY" },
        { label: "美式炸鸡", value: "MSZJ" },
        { label: "牧歌牛包子", value: "MGBZ" },
        { label: "铜锅涮肉", value: "TGSR" },
        { label: "辣辣卤鸭货", value: "LLYH" },
        { label: "重庆毛肚火锅", value: "CQHG" },
        { label: "社区卤菜厨房", value: "SQCF" }
      ],
      groupGoodsMainFileList: [],
      groupGoodsNextFileList: [],
      groupGoodsQualificationFileList: [],
      hideGroupGoodsMainUpload: false,
      hideGroupGoodsNextUpload: false,
      hideGroupGoodsQualificationUpload: false,
      groupGoodsEditorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'font': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image', 'video']
            ]
          }
        },
        placeholder: '请输入商品简介...',
        theme: 'snow'
      }
    };
  },
  mounted() {
    this.getList();
    this.getGroupGoodsOptionsStore();
    this.getGroupGoodsSupplyOptionsAll();
  },
  methods: {
    tableBtn(data, type) {
      switch (type) {
        case "view":
          this.title = "查看详情";
          this.form.id = data.id;
          this.form.configName = data.configName;
          this.form.buyAccount = data.buyAccount;
          this.form.giftAccount = data.giftAccount;
          this.form.allowance = data.allowance || 0;
          this.form.remark = data.remark || "";
          this.form.img = data.img;
          if (data.img) {
            this.imgFileList = [{ url: data.img }];
            this.hideImgUpload = true;
          }
          this.addEditShow = true;
          break;
        case "edit":
          this.title = "修改";
          this.form.id = data.id;
          this.form.configName = data.configName;
          this.form.buyAccount = data.buyAccount;
          this.form.giftAccount = data.giftAccount;
          this.form.allowance = data.allowance || 0;
          this.form.remark = data.remark || "";
          this.form.img = data.img;
          if (data.img) {
            this.imgFileList = [{ url: data.img }];
            this.hideImgUpload = true;
          }
          this.addEditShow = true;
          break;
        case "delete":
          this.$confirm("确定要删除该配置吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            deleteBawangcanApi(data.id).then(res => {
              this.$message.success("删除成功!");
              this.getList();
            });
          }).catch(() => {
            this.$message.info("已取消删除");
          });
          break;
      }
    },
    getList() {
      getBawangcanListApi({ current: 1, size: 100 }).then(res => {
        this.dataList = res.records || [];
      });
    },
    confirmBtn() {
      this.$refs["formRef"].validate(valid => {
        if (valid) {
          if (this.form.id) {
            editBawangcanApi(this.form).then(res => {
              this.$message.success("修改成功!");
              this.dialogClose();
              this.getList();
            });
          } else {
            console.log(this.form);
            
            if(this.form.bwcGroupId==1){
              this.form.ifBawangcan=1;
            }
            if(this.form.bwGroupId==2){
              this.form.ifFuli=1;
            }
            addBawangcanApi(this.form).then(res => {
              this.$message.success("新增成功!");
              this.dialogClose();
              this.getList();
            });
          }
        } else {
          return false;
        }
      });
    },
    addBtn() {
      this.title = "添加";
      this.form.id = undefined;
      this.form.configName = "";
      this.form.buyAccount = 0;
      this.form.giftAccount = 0;
      this.form.allowance = 0;
      this.form.remark = "";
      this.form.img = "";
      this.imgFileList = [];
      this.hideImgUpload = false;
      this.addEditShow = true;
    },
    dialogClose() {
      this.form.id = undefined;
      this.form.configName = "";
      this.form.buyAccount = 0;
      this.form.giftAccount = 0;
      this.form.allowance = 0;
      this.form.remark = "";
      this.form.img = "";
      this.imgFileList = [];
      this.hideImgUpload = false;
      if (this.$refs["formRef"]) {
        this.$refs["formRef"].resetFields();
      }
      this.addEditShow = false;
    },
    getUploadUrl() {
      return `${process.env.VUE_APP_URE}/file/uploadFile`;
    },
    uploadBefore(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isMp4 = file.type === 'video/mp4';
      if (!isJPG && !isPNG && !isMp4) {
        this.$message.error('上传图片只能是 JPG 或者 PNG 格式!');
      }
      return isJPG || isPNG || isMp4;
    },
    uploadSuccessImg(file, fileList) {
      let obj = { url: file.data };
      this.imgFileList.push(obj);
      this.form.img = file.data;
      if (this.imgFileList.length >= this.limitImg) {
        this.hideImgUpload = true;
      }
      this.$refs.imgUpload.clearFiles();
    },
    uploadRemoveImg(file) {
      for (let i = 0; i < this.imgFileList.length; i++) {
        if (this.imgFileList[i].url == file.url) {
          this.imgFileList.splice(i, 1);
          this.form.img = "";
          this.hideImgUpload = false;
        }
      }
    },
    changeIsGroupHotSale(type,e) {

      console.log('是否限购',type,e)

      changeGroupHotSaleApi({ goodsId: e.row.id, isGroupHotSale: e.row.isGroupHotSale, groupHotSaleNum: 1 }).then(res => {
        console.log("默认", res)
      })


    },
        changeDplimit(type,e) {

      console.log('是否限购',type,e)

      changedplimitSaleApi({ goodsId: e.row.id, dplimit: e.row.dplimit}).then(res => {
        console.log("默认", res)
      })



    },
    handleRemove(file) {
      let index = this.imgFileList.findIndex(f => f.url === file.url);
      if (index !== -1) {
        this.imgFileList.splice(index, 1);
        this.form.img = "";
        this.hideImgUpload = false;
      }
    },
    isImage(src) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const pureSrc = src.split('?')[0];
      const ext = '.' + pureSrc.split('.').pop().toLowerCase();
      return imageExtensions.includes(ext);
    },
    isVideo(src) {
      const videoExtensions = ['.mp4', '.avi', '.mkv', '.flv', '.webm'];
      const ext = '.' + src.split('.').pop().toLowerCase();
      return videoExtensions.includes(ext);
    },

    addGroup(configRow) {
      this.groupTitle = "新增分组";
      this.currentConfigId = configRow.id;
      this.groupForm.id = undefined;
      this.groupForm.groupName = "";
      this.groupForm.remark = "";
      this.groupForm.image = "";
      this.groupForm.configId = configRow.id;
      this.groupImgFileList = [];
      this.hideGroupImgUpload = false;
      this.groupShow = true;
    },

    editGroup(configRow, groupRow) {
      this.groupTitle = "修改分组";
      this.currentConfigId = configRow.id;
      this.groupForm.id = groupRow.id;
      this.groupForm.groupName = groupRow.groupName;
      this.groupForm.remark = groupRow.remark || "";
      this.groupForm.image = groupRow.image || "";
      this.groupForm.configId = configRow.id;
      if (groupRow.image) {
        this.groupImgFileList = [{ url: groupRow.image }];
        this.hideGroupImgUpload = true;
      } else {
        this.groupImgFileList = [];
        this.hideGroupImgUpload = false;
      }
      this.groupShow = true;
    },

    deleteGroup(id) {
      this.$confirm("确定要删除该分组吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteBwcGroupApi({ id }).then(res => {
          this.$message.success("删除成功!");
          this.getList();
        });
      }).catch(() => {
        this.$message.info("已取消删除");
      });
    },

    confirmGroupBtn() {
      this.$refs["groupFormRef"].validate(valid => {
        if (valid) {
          if (this.groupForm.id) {
            editBwcGroupApi(this.groupForm).then(res => {
              this.$message.success("修改成功!");
              this.groupDialogClose();
              this.getList();
            });
          } else {
            addBwcGroupApi(this.groupForm).then(res => {
              this.$message.success("新增成功!");
              this.groupDialogClose();
              this.getList();
            });
          }
        } else {
          return false;
        }
      });
    },

    groupDialogClose() {
      this.groupForm.id = undefined;
      this.groupForm.groupName = "";
      this.groupForm.remark = "";
      this.groupForm.image = "";
      this.groupForm.configId = "";
      this.groupImgFileList = [];
      this.hideGroupImgUpload = false;
      if (this.$refs["groupFormRef"]) {
        this.$refs["groupFormRef"].resetFields();
      }
      this.groupShow = false;
    },

    uploadSuccessGroupImg(file, fileList) {
      let obj = { url: file.data };
      this.groupImgFileList.push(obj);
      this.groupForm.image = file.data;
      if (this.groupImgFileList.length >= 1) {
        this.hideGroupImgUpload = true;
      }
      this.$refs.groupImgUpload.clearFiles();
    },

    uploadRemoveGroupImg(file) {
      for (let i = 0; i < this.groupImgFileList.length; i++) {
        if (this.groupImgFileList[i].url == file.url) {
          this.groupImgFileList.splice(i, 1);
          this.groupForm.image = "";
          this.hideGroupImgUpload = false;
        }
      }
    },

    handleGroupRemove(file) {
      let index = this.groupImgFileList.findIndex(f => f.url === file.url);
      if (index !== -1) {
        this.groupImgFileList.splice(index, 1);
        this.groupForm.image = "";
        this.hideGroupImgUpload = false;
      }
    },

    showGroupGoods(configRow, groupRow) {
      this.groupGoodsTitle = `${groupRow.groupName} - 商品列表`;
      this.currentGroupId = groupRow.id;
      this.currentGroupConfigId = configRow.id;
      this.groupGoodsShow = true;
      this.getGroupGoodsList(groupRow.id);
    },

    getGroupGoodsList(groupId) {
      this.$api.goods_GCList({
        data: {
          bwcGroupId: groupId,
          "pageModel.pageNo": 1,
          "pageModel.pageSize": 100
        },
        success: res => {
          const records = res.records || [];
          for (let id = 0; id < records.length; id++) {
            const element = records[id];
            let headImgArray = [];
            if (element.headImg) {
                const trimmedStr = element.headImg.slice(1, -1);
                if (trimmedStr) {
                    headImgArray = trimmedStr.split(',');
                }
            }
            element.headImg = headImgArray || null;
          }
          this.groupGoodsList = records;
        }
      });
    },

    addGroupGoods() {
      this.groupGoodsFormTitle = "新增商品";
      this.groupGoodsForm.id = undefined;
      this.groupGoodsForm.name = "";
      this.groupGoodsForm.retailPrice = "";
      this.groupGoodsForm.atype = "";
      this.groupGoodsForm.sort = "";
      this.groupGoodsForm.reorder = null;
      this.groupGoodsForm.brand = "";
      this.groupGoodsForm.score = "";
      this.groupGoodsForm.jingdou = "";
      this.groupGoodsForm.details = "";
      this.groupGoodsForm.headImg = [];
      this.groupGoodsForm.imgList = [];
      this.groupGoodsForm.unit = "";
      this.groupGoodsForm.skuList = null;
      this.groupGoodsForm.goodType = 1;
      this.groupGoodsForm.freight = 0;
      this.groupGoodsForm.isExplosiveProducts = 0;
      this.groupGoodsForm.isBanjiaProducts = 0;
      this.groupGoodsForm.isVipFreeProducts = 0;
      this.groupGoodsForm.noreason = 0;
      this.groupGoodsForm.prem = 0;
      this.groupGoodsForm.instantrefund = 0;
      this.groupGoodsForm.dishType = "";
      this.groupGoodsForm.storeId = "";
      this.groupGoodsForm.categoryId = "";
      this.groupGoodsForm.salecomm = 0;
      this.groupGoodsForm.discount = 0;
      this.groupGoodsForm.ifBawangcan = 0;
      this.groupGoodsForm.ifFuli = 0;
      this.groupGoodsForm.qualification = [];
      this.groupGoodsForm.groupId = this.currentGroupId;
      this.groupGoodsCommission = "";
      this.groupGoodsFreightValue = "";
      this.groupGoodsUnnits = [
        {
          unitNum: '',
          unit: '',
          stock: '',
          price: '',
          membershipPrice: '',
          vipPrice: '',
          qcPrice: '',
          communityLeaderPrice: '',
          shipcost: ''
        }
      ];
      this.groupGoodsMainFileList = [];
      this.groupGoodsNextFileList = [];
      this.groupGoodsQualificationFileList = [];
      this.hideGroupGoodsMainUpload = false;
      this.hideGroupGoodsNextUpload = false;
      this.hideGroupGoodsQualificationUpload = false;
      this.groupGoodsFormShow = true;
    },

editGroupGoods(row) {
  this.groupGoodsFormTitle = "修改商品";
  
  goods_GCGetGoodsInfo({ goodsId: row.id }).then(res => {
    console.log('商品详情接口返回:', res);
    
    // 保存门店ID和分类ID
    const storeId = res.storeId || "";
    const categoryId = res.categoryId || "";
    
    // 表单数据赋值
    const formData = {
      id: res.id,
      name: res.name || "",
      retailPrice: res.retailPrice || "",
      atype: res.atype || "",
      sort: res.sort || "",
      reorder: res.reorder || null,
      brand: res.brand || "",
      score: res.score || "",
      jingdou: res.jingdou || "",
      details: res.details || "",
      headImg: [],
      imgList: [],
      unit: res.unit || "",
      skuList: res.skuList || null,
      goodType: res.goodType || 1,
      freight: res.freight || 0,
      isExplosiveProducts: res.isExplosiveProducts ? 1 : 0,
      isBanjiaProducts: res.isBanjiaProducts ? 1 : 0,
      isVipFreeProducts: res.isVipFreeProducts ? 1 : 0,
      noreason: res.noreason != null ? res.noreason : 0,
      prem: res.prem != null ? res.prem : 0,
      instantrefund: res.instantrefund != null ? res.instantrefund : 0,
      dishType: Array.isArray(res.type) ? (res.type[0] || '') : (res.type || res.dishType || ''),
      storeId: storeId,
      categoryId: categoryId,
      salecomm: res.salecomm || 0,
      discount: res.discount || 0,
      ifBawangcan: res.ifBawangcan != null ? res.ifBawangcan : 0,
      ifFuli: res.ifFuli != null ? res.ifFuli : 0,
      qualification: [],
      groupId: this.currentGroupId,
      topPrice: res.topPrice || null,
      decsPrice: res.decsPrice || null
    };
    
    this.groupGoodsForm = Object.assign({}, this.groupGoodsForm, formData);
    this.groupGoodsCommission = res.commission || "";
    this.groupGoodsFreightValue = res.identity || "";
    
    // 处理规格数据
    if (res.skuList && res.skuList.length > 0) {
      this.groupGoodsUnnits = res.skuList.map(item => {
        const unit = item.name.slice(-1);
        const unitNum = item.name.slice(0, -1);
        return {
          ...item,
          unit,
          unitNum
        };
      });
    } else {
      this.groupGoodsUnnits = [{
        unitNum: '',
        unit: '',
        stock: '',
        price: '',
        membershipPrice: '',
        vipPrice: '',
        qcPrice: '',
        communityLeaderPrice: '',
        shipcost: ''
      }];
    }
    
    // 处理主图
    if (res.headImg) {
      let imgArray = [];
      if (Array.isArray(res.headImg)) {
        imgArray = res.headImg;
      } else if (typeof res.headImg === 'string' && res.headImg.startsWith('[')) {
        imgArray = res.headImg.slice(1, -1).split(',').map(url => url.trim());
      } else if (typeof res.headImg === 'string') {
        imgArray = [res.headImg];
      }
      this.groupGoodsForm.headImg = imgArray;
      this.groupGoodsMainFileList = imgArray.map(url => ({ url }));
      this.hideGroupGoodsMainUpload = this.groupGoodsMainFileList.length >= 3;
    } else {
      this.groupGoodsForm.headImg = [];
      this.groupGoodsMainFileList = [];
      this.hideGroupGoodsMainUpload = false;
    }
    
    // 处理配图
    if (res.imgList) {
      let imgList = [];
      if (Array.isArray(res.imgList)) {
        imgList = res.imgList;
      } else if (typeof res.imgList === 'string' && res.imgList.startsWith('[')) {
        imgList = res.imgList.slice(1, -1).split(',').map(url => url.trim());
      } else if (typeof res.imgList === 'string') {
        imgList = [res.imgList];
      }
      this.groupGoodsForm.imgList = imgList;
      this.groupGoodsNextFileList = imgList.map(url => ({ url }));
      this.hideGroupGoodsNextUpload = this.groupGoodsNextFileList.length >= 5;
    } else {
      this.groupGoodsForm.imgList = [];
      this.groupGoodsNextFileList = [];
      this.hideGroupGoodsNextUpload = false;
    }
    
    // 处理经营资质
    if (res.qualification) {
      let qualArr = [];
      if (Array.isArray(res.qualification)) {
        qualArr = res.qualification;
      } else if (typeof res.qualification === 'string' && res.qualification.startsWith('[')) {
        qualArr = res.qualification.slice(1, -1).split(',').map(url => url.trim());
      } else if (typeof res.qualification === 'string') {
        qualArr = [res.qualification];
      }
      this.groupGoodsForm.qualification = qualArr;
      this.groupGoodsQualificationFileList = qualArr.map(url => ({ url }));
      this.hideGroupGoodsQualificationUpload = this.groupGoodsQualificationFileList.length >= 3;
    } else {
      this.groupGoodsForm.qualification = [];
      this.groupGoodsQualificationFileList = [];
      this.hideGroupGoodsQualificationUpload = false;
    }
    
    // 设置门店ID并加载分类列表
    if (storeId) {
      // 先设置门店ID，然后加载分类列表
      this.groupGoodsForm.storeId = storeId;
      this.getGroupGoodsOptionsCategory(storeId, () => {
        // 分类列表加载完成后，设置分类ID并打开弹窗
        this.groupGoodsForm.categoryId = categoryId;
        this.groupGoodsFormShow = true;
      });
    } else {
      this.groupGoodsForm.storeId = storeId;
      this.groupGoodsForm.categoryId = categoryId;
      // 直接打开弹窗
      this.groupGoodsFormShow = true;
    }
    
  }).catch(err => {
    console.error('获取商品详情失败:', err);
    this.$message.error('获取商品详情失败');
  });
},

    changeGroupGoodsState(e) {
      this.$api.goods_GCUpdateState({
        data: {
          goodsId: e.row.id
        },
        success: res => {
          if (res) {
            this.$message.success('商品上架成功')
          } else {
            this.$message.info('商品已下架')
          }
        },
      })
    },
    deleteGroupGoods(id) {
      this.$confirm("确定要删除该商品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        goods_GCRemoveGoodsById({ goodsId:id }).then(res => {
          this.$message.success("删除成功!");
          this.getGroupGoodsList(this.currentGroupId);
        });
      }).catch(() => {
        this.$message.info("已取消删除");
      });
    },

    confirmGroupGoodsBtn() {
      this.$refs["groupGoodsFormRef"].validate(valid => {
        if (valid) {
          const us = JSON.parse(JSON.stringify(this.groupGoodsUnnits));
          const newus = us?.map((item, i) => {
            return {
              membershipPrice: Number(item.membershipPrice),
              price: Number(item.price),
              communityLeaderPrice: Number(item.communityLeaderPrice),
              shipcost: Number(item.shipcost),
              vipPrice: Number(item.vipPrice),
              qcPrice: Number(item.qcPrice),
              name: item.unitNum + item.unit,
              stock: Number(item.stock)
            }
          });
          const skulist = newus.filter(item => item.name);
          const obj = {
            ...this.groupGoodsForm,
            bwcGroupId: this.currentGroupId,
            commission: this.groupGoodsCommission,
            topPrice: this.groupGoodsForm.isExplosiveProducts ? parseFloat(this.groupGoodsForm.topPrice) : null,
            decsPrice: this.groupGoodsForm.isExplosiveProducts ? parseFloat(this.groupGoodsForm.decsPrice) : null,
            isExplosiveProducts: this.groupGoodsForm.isExplosiveProducts,
            isBanjiaProducts: this.groupGoodsForm.isBanjiaProducts,
            isVipFreeProducts: this.groupGoodsForm.isVipFreeProducts,
            noreason: this.groupGoodsForm.noreason,
            prem: this.groupGoodsForm.prem,
            instantrefund: this.groupGoodsForm.instantrefund,
            qualification: Array.isArray(this.groupGoodsForm.qualification) ? this.groupGoodsForm.qualification.join(',') : (this.groupGoodsForm.qualification || ''),
            goodType: 1,
            reorder: this.groupGoodsForm.reorder,
            brand: this.groupGoodsForm.brand,
            salecomm: this.groupGoodsForm.salecomm
          };
          delete obj.skuList;
          if (newus.length > 0 && newus[0] && newus[0].name) {
            obj.skuList = skulist;
          }
          if (this.groupGoodsFreightValue) {
            obj.identity = this.groupGoodsFreightValue;
          }
          if (this.groupGoodsFreightValue == 'z') {
            delete obj.freight;
          }

          if (this.groupGoodsForm.id) {
            goods_GCEditGoods(obj).then(res => {
              this.$message.success("修改成功!");
              this.groupGoodsFormDialogClose();
              this.getGroupGoodsList(this.currentGroupId);
            });
          } else {
            goods_GCAddGoods(obj).then(res => {
              this.$message.success("新增成功!");
              this.groupGoodsFormDialogClose();
              this.getGroupGoodsList(this.currentGroupId);
            });
          }
        } else {
          return false;
        }
      });
    },

    groupGoodsDialogClose() {
      this.groupGoodsShow = false;
      this.groupGoodsList = [];
      this.currentGroupId = "";
    },

    groupGoodsFormDialogClose() {
      this.groupGoodsForm.id = undefined;
      this.groupGoodsForm.name = "";
      this.groupGoodsForm.retailPrice = "";
      this.groupGoodsForm.atype = "";
      this.groupGoodsForm.sort = "";
      this.groupGoodsForm.reorder = null;
      this.groupGoodsForm.brand = "";
      this.groupGoodsForm.score = "";
      this.groupGoodsForm.jingdou = "";
      this.groupGoodsForm.details = "";
      this.groupGoodsForm.headImg = [];
      this.groupGoodsForm.imgList = [];
      this.groupGoodsForm.unit = "";
      this.groupGoodsForm.skuList = null;
      this.groupGoodsForm.goodType = 1;
      this.groupGoodsForm.freight = 0;
      this.groupGoodsForm.isExplosiveProducts = 0;
      this.groupGoodsForm.isBanjiaProducts = 0;
      this.groupGoodsForm.isVipFreeProducts = 0;
      this.groupGoodsForm.noreason = 0;
      this.groupGoodsForm.prem = 0;
      this.groupGoodsForm.instantrefund = 0;
      this.groupGoodsForm.dishType = "";
      this.groupGoodsForm.storeId = "";
      this.groupGoodsForm.categoryId = "";
      this.groupGoodsForm.salecomm = 0;
      this.groupGoodsForm.discount = 0;
      this.groupGoodsForm.ifBawangcan = 0;
      this.groupGoodsForm.ifFuli = 0;
      this.groupGoodsForm.qualification = [];
      this.groupGoodsForm.groupId = "";
      this.groupGoodsCommission = "";
      this.groupGoodsFreightValue = "";
      this.groupGoodsUnnits = [{
        unitNum: '',
        unit: '',
        stock: '',
        price: '',
        membershipPrice: '',
        vipPrice: '',
        qcPrice: '',
        communityLeaderPrice: '',
        shipcost: ''
      }];
      this.groupGoodsMainFileList = [];
      this.groupGoodsNextFileList = [];
      this.groupGoodsQualificationFileList = [];
      this.hideGroupGoodsMainUpload = false;
      this.hideGroupGoodsNextUpload = false;
      this.hideGroupGoodsQualificationUpload = false;
      if (this.$refs["groupGoodsFormRef"]) {
        this.$refs["groupGoodsFormRef"].resetFields();
      }
      this.groupGoodsFormShow = false;
    },

    uploadSuccessGroupGoodsMain(file, fileList) {
      let obj = { url: file.data };
      this.groupGoodsMainFileList.push(obj);
      this.groupGoodsForm.headImg = this.groupGoodsMainFileList.map(item => item.url);
      if (this.groupGoodsMainFileList.length >= 3) {
        this.hideGroupGoodsMainUpload = true;
      }
      this.$refs.groupGoodsMainUpload.clearFiles();
    },

    uploadRemoveGroupGoodsMain(file) {
      for (let i = 0; i < this.groupGoodsMainFileList.length; i++) {
        if (this.groupGoodsMainFileList[i].url == file.url) {
          this.groupGoodsMainFileList.splice(i, 1);
          this.groupGoodsForm.headImg = this.groupGoodsMainFileList.map(item => item.url);
          this.hideGroupGoodsMainUpload = false;
        }
      }
    },

    handleGroupGoodsMainRemove(file) {
      let index = this.groupGoodsMainFileList.findIndex(f => f.url === file.url);
      if (index !== -1) {
        this.groupGoodsMainFileList.splice(index, 1);
        this.groupGoodsForm.headImg = this.groupGoodsMainFileList.map(item => item.url);
        this.hideGroupGoodsMainUpload = false;
      }
    },

    uploadSuccessGroupGoodsNext(file, fileList) {
      let obj = { url: file.data };
      this.groupGoodsNextFileList.push(obj);
      this.groupGoodsForm.imgList = this.groupGoodsNextFileList.map(item => item.url);
      if (this.groupGoodsNextFileList.length >= 5) {
        this.hideGroupGoodsNextUpload = true;
      }
      this.$refs.groupGoodsNextUpload.clearFiles();
    },

    uploadRemoveGroupGoodsNext(file) {
      for (let i = 0; i < this.groupGoodsNextFileList.length; i++) {
        if (this.groupGoodsNextFileList[i].url == file.url) {
          this.groupGoodsNextFileList.splice(i, 1);
          this.groupGoodsForm.imgList = this.groupGoodsNextFileList.map(item => item.url);
          this.hideGroupGoodsNextUpload = false;
        }
      }
    },

    handleGroupGoodsNextRemove(file) {
      let index = this.groupGoodsNextFileList.findIndex(f => f.url === file.url);
      if (index !== -1) {
        this.groupGoodsNextFileList.splice(index, 1);
        this.groupGoodsForm.imgList = this.groupGoodsNextFileList.map(item => item.url);
        this.hideGroupGoodsNextUpload = false;
      }
    },

    uploadSuccessGroupGoodsQualification(file, fileList) {
      let obj = { url: file.data };
      this.groupGoodsQualificationFileList.push(obj);
      this.groupGoodsForm.qualification = this.groupGoodsQualificationFileList.map(item => item.url);
      if (this.groupGoodsQualificationFileList.length >= 3) {
        this.hideGroupGoodsQualificationUpload = true;
      }
      this.$refs.groupGoodsQualificationUpload.clearFiles();
    },

    uploadRemoveGroupGoodsQualification(file) {
      for (let i = 0; i < this.groupGoodsQualificationFileList.length; i++) {
        if (this.groupGoodsQualificationFileList[i].url == file.url) {
          this.groupGoodsQualificationFileList.splice(i, 1);
          this.groupGoodsForm.qualification = this.groupGoodsQualificationFileList.map(item => item.url);
          this.hideGroupGoodsQualificationUpload = false;
        }
      }
    },

    handleGroupGoodsQualificationRemove(file) {
      let index = this.groupGoodsQualificationFileList.findIndex(f => f.url === file.url);
      if (index !== -1) {
        this.groupGoodsQualificationFileList.splice(index, 1);
        this.groupGoodsForm.qualification = this.groupGoodsQualificationFileList.map(item => item.url);
        this.hideGroupGoodsQualificationUpload = false;
      }
    },

    groupGoodsAddUnit() {
      this.groupGoodsUnnits.push({
        unitNum: '',
        unit: '',
        stock: '',
        price: '',
        membershipPrice: '',
        vipPrice: '',
        qcPrice: '',
        communityLeaderPrice: '',
        shipcost: ''
      });
    },

    groupGoodsReduce(index) {
      this.groupGoodsUnnits.splice(index, 1);
    },

    getGroupGoodsOptionsStore() {
      let obj = {
        "pageModel.pageNo": 1,
        "pageModel.pageSize": 2000,
        goodType: 1
      }
      this.$api.store_list({
        data: obj,
        success: res => {
          let ary = []
          for (let i = 0; i < res.records.length; i++) {
            const item = {
              label: res.records[i].storeName,
              value: res.records[i].id
            }
            ary.push(item)
          }
          this.groupGoodsOptionsStore = ary
        }
      })
    },

    getGroupGoodsSupplyOptionsAll() {
      getSupplyOptions().then(res => {
        let ary = []
        for (let i = 0; i < res.length; i++) {
          const item = {
            label: res[i].name,
            value: res[i].id
          }
          ary.push(item)
        }
        this.groupGoodsType = ary
      })
    },

getGroupGoodsOptionsCategory(storeId, callback) {
  let obj = { storeId: storeId }
  getClassify(obj).then(res => {
    let ary = []
    for (let i = 0; i < res.length; i++) {
      const item = {
        label: res[i].name,
        value: res[i].id
      }
      ary.push(item)
    }
    this.groupGoodsOptionsCategory = ary
    // 执行回调
    if (callback && typeof callback === 'function') {
      callback()
    }
  }).catch(err => {
    console.error('获取分类列表失败:', err)
    // 即使失败也要执行回调，保证弹窗能打开
    if (callback && typeof callback === 'function') {
      callback()
    }
  })
},

    onGroupGoodsStoreChange(storeId) {
      if (storeId) {
        this.getGroupGoodsOptionsCategory(storeId)
      } else {
        this.groupGoodsOptionsCategory = []
        this.groupGoodsForm.categoryId = ""
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "@/assets/css/publicStyle.less";

.container {
  .box {
    display: block;
    width: 100%;
    padding: 20px 16px;
    box-sizing: border-box;
    background-color: #ffffff;

    .header {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 20px;
    }

    .list {
      display: block;
      width: 100%;
    }
  }
}

.custom-upload-item {
  position: relative;
  width: 100%;
  height: 100%;

  .el-upload-list__item-actions {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  .el-upload-list__item-delete {
    color: #fff;
    font-size: 18px;
    cursor: pointer;
  }
}

.hide {
  .el-upload--picture-card {
    display: none;
  }
}

.group-section {
  padding: 10px;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 14px;
}

.group-goods-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
}

.unitBox {
  border: 1px solid #eeeeee;
  padding: 10px;
  margin-bottom: 20px;
  .unitTop {
    display: flex;
  }
  .unitBottom {
    display: flex;
    margin-top: 20px;
  }
  .pricebox {
    display: flex;
  }
  .input {
    margin-right: 5px;
    width: 150px;
  }
  .inputprice {
    width: 86px;
  }
  .goodsItem {
    display: flex;
    align-items: center;
    .span {
      text-wrap: nowrap;
      margin-right: 5px;
      font-weight: bold;
    }
    .spankc {
      font-weight: normal;
      color: #606266;
    }
  }
  .butdel {
    background: #ffffff;
    color: #333333;
  }
}

.addbutb {
  margin-left: 10px;
  background: #FF6321!important;
  color: #ffffff!important;
  margin-top: 20px;
}

.goods-attr-line {
  display: flex;
  align-items: center;
  gap: 20px;
  .attr-label {
    font-weight: normal;
    color: #606266;
  }
}
</style>